import { useState } from 'react'
import classNames from 'classnames'
import { IconCopyButton, Typography } from 'shared/ui'
import { makeTextFieldElement, TextFieldPlaceholder } from 'shared/ui/TextField'
import styles from '../styles.module.scss'

export const LinkContent = ({ link }: { link: string }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div>
      <div className={classNames(styles.grid, styles.linkWrap)}>
        <Typography ariaLabel='Link' variant='text-input-field' className={styles.label}>
          Link
        </Typography>
        <TextFieldPlaceholder
          className={styles.linkWrap}
          size='small'
          variant='outline'
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          placeholder={
            <Typography
              tag='div'
              ariaLabel='LinkValue'
              variant='text-input-field'
              color='var(--content-primary-primary)'
              ellipsis
              width='100%'
              tooltipProps={{ label: link, placement: 'top' }}
            >
              {link}
            </Typography>
          }
          rightActions={[
            makeTextFieldElement({
              element: isHovered ? (
                <IconCopyButton value={link} toastTitle={'Link copied'} toastType={'success'} />
              ) : null,
            }),
          ]}
        />
      </div>
    </div>
  )
}
